import { render, staticRenderFns } from "./listaActividades.vue?vue&type=template&id=7b42d503"
import script from "./listaActividades.vue?vue&type=script&lang=js"
export * from "./listaActividades.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports